import type React from 'react';
import { TaskDetailsDrawer } from '@/components/tasks/task-details-drawer';
import type { UpdateTaskApiRequest } from '@/types/api/tasks';
import type { UnifiedTask } from '@/types/tasks';

interface TaskDrawerRouterProps {
  task: UnifiedTask | null;
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onSave?: (taskId: string, data: UpdateTaskApiRequest) => void;
  onComplete?: (taskId: string) => void;
}

/**
 * Smart Task Drawer Router
 *
 * Shows task details with source record summary.
 * Users can navigate to the full source record for editing.
 */
export const TaskDrawerRouter: React.FC<TaskDrawerRouterProps> = ({ task, open, onOpenChange, onSave, onComplete }) => {
  if (!task) {
    return null;
  }

  return (
    <TaskDetailsDrawer task={task} open={open} onOpenChange={onOpenChange} onSave={onSave} onComplete={onComplete} />
  );
};
